export const convertUTCToLocal = (utcDateString) => {
    if (!utcDateString) return null; // Handle null or undefined input

    // Create Date object from UTC string
    const utcDate = new Date(utcDateString);

    // Convert to system's locale date format without time
    return utcDate.toLocaleDateString();
};

export const convertISOToLocal = (isoDateString) => {
    if (!isoDateString) return null; // Handle null or invalid input
    const date = new Date(isoDateString);
    return date.toLocaleString();
};

// Function to return date in YYYY-MM-DD format
export const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return null; // Handle null or invalid input

    const date = new Date(dateString);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero
    const day = String(date.getDate()).padStart(2, '0'); // Add leading zero

    return `${year}-${month}-${day}`;
};